// Login Action Types
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';
export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN';
export const SET_SERVICES = 'SET_MENUS';

// Logout Action Types
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_LOGOUT_SUCCESS = 'AUTH_LOGOUT_SUCCESS';

// Permissions Action Types
export const AUTH_LOAD_PERMISSIONS = 'AUTH_LOAD_PERMISSIONS';
export const AUTH_LOAD_PERMISSIONS_SUCCESS = 'AUTH_LOAD_PERMISSIONS_SUCCESS';
export const AUTH_LOAD_PERMISSIONS_FAILURE = 'AUTH_LOAD_PERMISSIONS_FAILURE';

// Initialize & Storage Action Types
export const AUTH_INITIALIZE = 'AUTH_INITIALIZE';
export const AUTH_SET_FROM_STORAGE = 'AUTH_SET_FROM_STORAGE';

// Refresh User Info Action Types
export const AUTH_REFRESH_USER = 'AUTH_REFRESH_USER';
export const AUTH_REFRESH_USER_SUCCESS = 'AUTH_REFRESH_USER_SUCCESS';

// Utility Action Types
export const AUTH_SET_LOADING = 'AUTH_SET_LOADING';
export const AUTH_CLEAR_ERROR = 'AUTH_CLEAR_ERROR';

export type AuthActionTypes =
  | typeof AUTH_LOGIN
  | typeof AUTH_LOGIN_SUCCESS
  | typeof AUTH_LOGIN_FAILURE
  | typeof AUTH_LOGOUT
  | typeof AUTH_LOGOUT_SUCCESS
  | typeof AUTH_LOAD_PERMISSIONS
  | typeof AUTH_LOAD_PERMISSIONS_SUCCESS
  | typeof AUTH_LOAD_PERMISSIONS_FAILURE
  | typeof AUTH_INITIALIZE
  | typeof AUTH_SET_FROM_STORAGE
  | typeof AUTH_REFRESH_USER
  | typeof AUTH_REFRESH_USER_SUCCESS
  | typeof AUTH_SET_LOADING
  | typeof AUTH_CLEAR_ERROR;
